import React from 'react';
import { HTMLInputProps, IRadioProps, Radio } from '@blueprintjs/core';
import { TLCode } from '../../../../common/enums';
import { TranslatedMessage } from '../../translation';
import { Overwrite } from '../../../../typings/typings';
import styled from '@emotion/styled';

const ContainerRadio = styled.div`
  display: flex;
  flex-direction: row;
  .bp3-radio {
    margin-top: 0px;
    margin-left: 5px;
  },
  `;

interface CommonRadioInputProps extends IRadioProps {
  value: string;
}

export type RadioInputProps = Overwrite<CommonRadioInputProps, { label?: TLCode }>;

const renderRadioInput = (props: CommonRadioInputProps & HTMLInputProps) => {
  return <Radio {...props} />;
};

const RadioInput = ({ label, ...otherProps }: RadioInputProps) => {
  if (label !== undefined) {
    const radio = renderRadioInput({ ...otherProps });
    return (
      <ContainerRadio>
        {radio}
        <TranslatedMessage id={label}/>
      </ContainerRadio>
    );
  } else {
    return renderRadioInput({ ...otherProps });
  }
};

export default RadioInput;
